export default __webpack_public_path__ + "static/media/rate_this_app_page.8fd729aa.png";